import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { getAmplifyConfig } from './config/amplify';
import { App } from './App';
import './styles/app.css';
import './styles/dashboard.css';

// Configure Amplify with Cognito settings from env vars
Amplify.configure(getAmplifyConfig());

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element not found');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
